/**
 * COUNTRY_MAP has the list of countries which has userCountries as the key and country codes as the value.
 * This is used when a user is searching for companies/contacts using Company/Contact dialog.
 */
export const COUNTRY_MAP = {
  Australia: ['Australia', 'AU', 'AUS', 'Commonwealth of Australia', 'Auz.'],
  Austria: ['Austria', 'AT', 'AUT'],
  Belgium: ['Belgium', 'BE', 'BEL'],
  China: ['CN', 'CHN', 'China'],
  'Czech Republic': ['Czech Republic', 'CZ', 'CZE'],
  Denmark: ['Denmark', 'DK', 'DNK', 'Kingdom of Denmark', 'Den.'],
  Finland: ['Finland', 'FI', 'FIN', 'Fin.', 'Republic of Finland'],
  France: ['France', 'FR', 'FRA'],
  Germany: ['Germany', 'DE', 'DEU'],
  Hungary: ['Hungary', 'HU', 'HUN'],
  India: ['IN', 'IND', 'India'],
  Italy: ['Italy', 'IT', 'ITA', 'Italia', 'Italian Republic'],
  Luxembourg: ['Luxembourg', 'LU', 'LUX'],
  Netherlands: ['Netherlands', 'NL', 'NLD'],
  Norway: ['Norway', 'NO', 'NOR', 'Kingdom of Norway', 'Nor.'],
  Poland: ['Poland', 'PL', 'POL', 'Republic of Poland', 'Polska'],
  Portugal: ['Portugal', 'PT', 'PRT'],
  Romania: ['Romania', 'RO', 'ROU'],
  Serbia: ['Serbia', 'RS', 'SRB'],
  Slovakia: ['Slovakia', 'SK', 'SVK'],
  Spain: ['Spain', 'ES', 'ESP'],
  Sweden: ['Sweden', 'SE', 'SWE', 'Kingdom of Sweden', 'Swe.'],
  Switzerland: ['Switzerland', 'CH', 'CHE'],
  'United Kingdom': [
    'UK',
    'United Kingdom',
    'GB',
    'GBR',
    'United Kingdom of Great Britain and Northern Irl',
    'Great Britain',
  ],
  'United States of America': ['United States', 'US', 'United States of America', 'USA'],
  'New Zealand': ['New Zealand', 'NZ', 'NZL'],
};
